import { render } from "./EmailReceivedPopUp.vue?vue&type=template&id=132b4852&scoped=true"
import script from "./EmailReceivedPopUp.vue?vue&type=script&lang=js"
export * from "./EmailReceivedPopUp.vue?vue&type=script&lang=js"

import "./EmailReceivedPopUp.vue?vue&type=style&index=0&id=132b4852&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132b4852"]])

export default __exports__